define('specific/footer/models/FooterModel', [

], function() {

    var FooterModel = Backbone.Model.extend({
        defaults: {
            "type": "footer",
            "viewId": "footer",
            "isReady": false
        }
    });

    return FooterModel;
});
